import { formatDate } from '@/utils';
import ORDER_API from '@/api/purchaseSalesCenter/wumaoPurchaseSales.js';

export default {
  methods: {
    // 过滤对象中属性为空的值
    filterEmpty(data) {
      const obj = {};
      for (let key in data) {
        if (data[key] || data[key] === 0 || typeof data[key] == 'boolean') {
          obj[key] = data[key];
        } else {
          obj[key] = null;
        }
      }
      return obj;
    },
    async handleSave(type) {
      try {
        console.log('点击了保存');
        const formData = await this.$refs.baseFormRef.getValidateFormData();
        // 如果当前状态为contractStatus=ZT061的时候提示下
        if (this.detailPageData?.contractStatus == 'ZT061' && this.detailPageData?.generateNo) {
          this.$message.success(`请同步修改已关联的销售合同号${this.detailPageData.generateNo}`);
        }
        if (type == '1') {
          try {
            await this.checkCompanyAndDepartment(formData.companyCode, formData.departmentCode);
          } catch {
            return;
          }
        }
        console.log(formData, '表三数据');
        const extendData = {
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          companyName: this.userInfo.companyName,
          companyCode: this.userInfo.companyCode,
        };
        const isCopy = this.$route.query.isCopy == 'true';
        const isNew = this.$route.query.status == 'create';
        console.log('222');
        // 关联合同
        const orderContractRelationshipList = this.$refs.relationInfo.getTableData().map((item) => {
          return {
            ...item,
            id: isCopy ? '' : item.id,
            ...extendData,
          };
        }); // 关联明细
        console.log('表格数据');
        const { orderDetailList, orderDetailDelIds } =
          await this.$refs.orderDetailListRef?.getValidateTableData(); // 产品明细
        console.log(orderDetailList, '===>数据');

        if (!orderDetailList.length) {
          this.$message.error('请添加商品数据！');
          return;
        }
        const attachmentList = this.$refs.fileTableRef?.getTableData().map((item) => {
          return {
            ...item,
            id: isCopy ? '' : item.id,
            ...extendData,
          };
        }); // 附件
        let orderInterest = {}; //逾期利息
        if (this.isShowOverdueInterestTab) {
          const orderInterestData = await this.$refs.overdueInterestRef.validate();
          if (orderInterestData.isOverDueInterest) {
            orderInterest = { ...orderInterestData, ...extendData };
          }
        }
        // 付款约定
        let orderAppointmentList = [];
        if (this.type == 'contract') {
          // 合同的时候才有这个
          orderAppointmentList = await this.$refs.orderAppointmentFormRef.getValidateFormData();
          orderAppointmentList = orderAppointmentList?.map((item, index) => {
            return {
              ...item,
              tenantCode: this.userInfo.tenantCode, // 租户编码
              companyCode: this.userInfo.companyCode, // 公司编码
              departmentCode: this.userInfo.departmentCode, // 部门编码
              companyName: this.userInfo.companyName, // 公司名字
              departmentName: this.userInfo.departmentName, // 部门名字
              // createBy: this.userInfo.createBy, // 创建者
              // lastModifiedBy: this.userInfo.createBy, // 最后更新者
              sortNo: index,
              orderType: 'purchase',
              contractId: formData?.id ? formData?.id : null, // 合同id
              contractNo: formData?.contractNo ? formData?.contractNo : null, // 合同号
            };
          });
          if (!orderAppointmentList.length) {
            orderAppointmentList = null;
          }
        }
        console.log(orderAppointmentList, '付款约定');
        // this.$refs.calculationInterest
        console.log(attachmentList, '附件');
        // 开票要求
        const remark = this.remark && this.remark.remark; // 开票申请
        const businessContractUnitPrice = orderDetailList.reduce(
          (cur, next) => cur + +next.businessContractUnitPrice,
          0
        );
        const businessContractTotalAmount = orderDetailList.reduce(
          (cur, next) => cur + +next.businessContractTotalAmount,
          0
        );
        const businessContractTaxAmount = orderDetailList.reduce(
          (cur, next) => cur + +next.businessContractTaxAmount,
          0
        );
        const businessContractPureAmount = orderDetailList.reduce(
          (cur, next) => cur + +next.businessContractPureAmount,
          0
        );
        const businessChangeUnitPrice = orderDetailList.reduce(
          (cur, next) => cur + +next.businessChangeUnitPrice,
          0
        );
        const businessChangeTotalAmount = orderDetailList.reduce(
          (cur, next) => cur + +next.businessChangeTotalAmount,
          0
        );
        const businessChangeTaxAmount = orderDetailList.reduce(
          (cur, next) => cur + +next.businessChangeTaxAmount,
          0
        );
        const businessChangePureAmount = orderDetailList.reduce(
          (cur, next) => cur + +next.businessChangePureAmount,
          0
        );
        console.log(formData);
        const contractBusinessCompanyName = formData?.companyName ? formData?.companyName : null;
        const contractBusinessCompanyNo = formData?.companyCode ? formData?.companyCode : null;
        const contractBusinessDepartment = formData?.departmentCode
          ? formData.departmentCode
          : null;

        const contractBusinessDepartmentName = formData?.departmentName
          ? formData.departmentName
          : null;
        // 重新计算 采购数量 和合同总金额
        const contractTotalAmount = orderDetailList.reduce(
          (cur, next) => cur + +next.businessContractTotalAmount,
          0
        );
        const purchaseQuantity = orderDetailList.reduce(
          (cur, next) => cur + +next.productQuantity,
          0
        );

        let postData = {
          ...this.filterEmpty(formData),
          ...this.filterEmpty(this.form),
          isDefault: formData.isDefault == '1' ? true : false,
          dataGroup: 'wm',
          contractTotalAmount:
            contractTotalAmount + '' == 'NaN' ? 0 : Number(contractTotalAmount).toFixed(6), // 重新计算金额
          purchaseQuantity:
            purchaseQuantity + '' == 'NaN' ? 0 : Number(purchaseQuantity).toFixed(8), // 重新计算采购数量
          contractStatus: this.contractStatus, // 根据条件来判断传递的值
          // 合同签署日
          signDate: formData.signDate ? `${formData.signDate}` : null,
          contractSalesmanNo: formData?.contractSalesmanNo,
          contractSalesmanName: formData?.contractSalesmanName,
          isRestrict: +formData?.isRestrict,
          // 手动添加
          personChargeName: formData?.contractSalesmanName,
          personChargeCode: formData?.contractSalesmanNo,
          contractCreateDate: formData?.contractCreateDate
            ? formatDate(formData?.contractCreateDate, false)
            : null,
          contractBusinessDepartment,
          contractBusinessDepartmentName,
          contractBusinessCompanyName,
          contractBusinessCompanyNo,
          contractDetailCategory: this.$route.query.type,
          tenantCode: this.userInfo.tenantCode,
          orderInterest, // 逾期利息

          isGenerateSales: formData?.isGenerateSales ? true : false,
          isPrepay:
            formData?.isPrepay && formData?.isPrepay.length != 0 && formData?.isPrepay == '1'
              ? 1
              : 0,
          isFixedPrice: formData.isFixedPrice == true || formData.isFixedPrice == '1' ? '1' : '0', // 是否定价
          contractCategory: this.$route.query.contractCategory, // 代表销售还是合同
          orderContractRelationshipList,
          orderAppointmentList,
          // businessChangeTotalAmount,
          productQuantity: formData.purchaseQuantity, // 商品数量
          lastestReceiveProductDay: formData.lastestReceiveProductDay
            ? formData.lastestReceiveProductDay
            : null,
          lastestPayMoneyDay: formData.lastestPayMoneyDay ? formData.lastestPayMoneyDay : null,
          lastestSendProductDay: formData.lastestSendProductDay
            ? formData.lastestSendProductDay
            : null,
          orderDetailList: orderDetailList.map((item) => {
            return {
              ...item,
              id: isCopy ? '' : item.id,
              ...extendData,
            };
          }),
          orderDetailDelIds, // 删除在id
          attachmentList,
          remark,
          type,
          id: isCopy || isNew ? null : formData?.id,
          // 新增字段根据表格来合计
          businessContractUnitPrice:
            businessContractUnitPrice + '' == 'NaN' ? 0 : businessContractUnitPrice,
          businessContractTotalAmount:
            businessContractTotalAmount + '' == 'NaN'
              ? 0
              : Number(businessContractTotalAmount).toFixed(6),
          businessContractTaxAmount:
            businessContractTaxAmount + '' == 'NaN' ? 0 : businessContractTaxAmount,
          businessContractPureAmount:
            businessContractPureAmount + '' == 'NaN' ? 0 : businessContractPureAmount,
          businessChangeUnitPrice:
            businessChangeUnitPrice + '' == 'NaN' ? 0 : businessChangeUnitPrice,
          businessChangeTaxAmount:
            businessChangeTaxAmount + '' == 'NaN' ? 0 : businessChangeTaxAmount,
          businessChangePureAmount:
            businessChangePureAmount + '' == 'NaN' ? 0 : businessChangePureAmount,
          businessChangeTotalAmount:
            businessChangeTotalAmount + '' == 'NaN'
              ? 0
              : Number(businessChangeTotalAmount).toFixed(6),
          oaId: this.userInfo.oaId, // 走oa审批
        };
        // 针对拷贝的时候特殊处理

        //协议不需要isPrepay
        if (this.$route.query.type == 'CG02' || this.type != 'contract') {
          delete postData.isPrepay;
        }

        // if (postData.contractValidEnd && postData.contractValidEnd.length >= 0) {
        //   postData.isNotEndDate = 1;
        // } else {
        //   postData.isNotEndDate = 0;
        // }

        const copyPostData = {
          copyFlag: isCopy ? '0' : '1',
          relationContractDetailCategory: this.$route.query.type, // 协议CG02 合同CG01
        };

        if (isCopy) {
          delete postData.contractStatus;
        }
        this.loading.startLoading();
        const { data } = await this.$axios.post(
          ORDER_API.SAVE_ORDER_API,
          isCopy && !isNew ? { ...postData, ...copyPostData } : postData
        );
        this.loading.endLoading();
        if (data.code == 0) {
          this.$message.success(data.msg);
          this.closeCurrentAndToList();
        } else {
          this.$message.error(data.msg);
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 复制事件
    copyBtnHandler() {
      const path = {
        path: '/salePurchase/wumaoAgreementCreate',
        name: 'wumaoAgreementCreate',
        meta: {
          keepAlive: false,
          title: '拷贝采购协议',
        },
        query: {
          type: this.$route.query.type,
          isEdit: 'false',
          isCopy: 'true',
          contractNo: this.$route.query.contractNo,
          id: this.$route.query.id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 创建合同
    createContractBtnHandler() {
      const path = {
        path: '/salePurchase/wumaoContractCreate',
        name: 'wumaoContractCreate',
        meta: {
          keepAlive: false,
          title: '创建采购合同',
        },
        query: {
          type: 'CG01',
          isEdit: 'false',
          isCopy: 'true',
          isNew: 'true',
          contractNo: this.$route.query.contractNo,
          dataGroup: 'wm',
          contractCategory: this.$route.query.contractCategory, // 合同总类
          copyFlag: '1',
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 删除
    deleteBtnHandler() {
      // const isGenerateSales = this.detailPageData.isGenerateSales;
      const { generateOrderStatus, generateNo, contractStatus, generateOrderStatusCode } =
        this.detailPageData;
      if (
        contractStatus == 'ZT05' &&
        generateOrderStatusCode &&
        generateOrderStatusCode != 'ZT05'
      ) {
        this.$message.error(`关联合同号${generateNo}状态为${generateOrderStatus},且不可删除`);
        return;
      }
      // const generateNo = this.detailPageData.generateNo;
      const message = generateNo ? `同时删除关联合同号${generateNo}` : '确定要删除?';
      this.$confirm(message, '删除提示', {})
        .then(async () => {
          this.loading.startLoading();
          const res = await this.$axios.post(ORDER_API.DELETE_ORDER_API, {
            ids: [this.$route.query.id],
            contractNos: [this.$route.query.contractNo],
            oaId: this.userInfo.oaId,
          });
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
            // 关闭
            this.closeCurrentAndToList();
            // this.$router.push({ path: '/salePurchase/purchaseOverview' });
          } else {
            this.$alert(res.data.msg);
          }
        })
        .catch(() => {
          this.loading.endLoading();
          this.$message({
            type: 'info',
            message: this.$t('confirm.deleteCancelled'),
          });
        });
    },
    closeCurrentAndToList() {
      console.log(this.$route.query.type, 'this.$route.query.type');
      const isEdit = this.$route.query.isEdit;
      const type = this.$route.query.type;
      let path = '';
      let name = '';
      if (type == 'CG02') {
        // 协议
        if (isEdit == 'true') {
          path = '/salePurchase/wumaoAgreementEdit';
          name = 'wumaoAgreementEdit';
        } else {
          path = '/salePurchase/wumaoAgreementCreate';
          name = 'wumaoAgreementCreate';
        }
      } else {
        // 合同
        if (isEdit == 'true') {
          path = '/salePurchase/wumaoContractEdit';
          name = 'wumaoContractEdit';
        } else {
          path = '/salePurchase/wumaoContractCreate';
          name = 'wumaoContractCreate';
        }
      }
      // 关闭当前tab导航 , 协议CG02 合同CG01
      this.$store.dispatch('tagsView/delView', {
        path,
        name,
        meta: {
          keepAlive: false,
          title: '',
        },
        query: {},
      });
      this.$router.push({ path: '/salePurchase/purchaseOverview' });
    },
    // 跳转到供货商发货指令
    goSupplierInstructLink() {
      const path = {
        path: '/wareHouse/addMateriaSupplierDeliveryOrder',
        name: 'addMateriaSupplierDeliveryOrder',
        meta: {
          keepAlive: false,
          title: '供货商发货指令维护',
        },
        query: {
          // type: this.$route.query.code,
          // isEdit: true,
          // isCopy: true,
          // dataGroup: this.$globalVar.dataGroup,
          contractNo: this.$route.query.contractNo,
          contractDetailNoList: this.detailPageData?.contractDetailNoList,
          // businessChangeUnitPrice,
          businessContractUnitPrice: this.detailPageData?.businessContractUnitPrice,
          financeContractTaxAmount: this.detailPageData?.businessContractTaxAmount,
          financeContractPureAmount: this.detailPageData?.businessContractPureAmount,
          businessContractTotalAmount: this.detailPageData?.businessContractTotalAmount,
          productQuantity: this.detailPageData?.productQuantity,
          isRestrict: this.detailPageData.isRestrict, // 是否定量
          // taxRate=0.11
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 关闭、激活、撤销
    updateStatusHandler(type) {
      const { generateNo } = this.detailPageData;
      // if (type == 2 && generateNo && generateOrderStatusCode == 'ZT03') {
      //   this.$message({
      //     message: `关联合同号${generateNo}状态为${generateOrderStatus}`,
      //     type: 'error',
      //   });
      //   return;
      // }

      const message =
        type == 2 && generateNo ? `同时撤回关联合同号${generateNo}` : '确定要更改合同状态';
      this.$confirm(message, '确认更改状态', {})
        .then(async () => {
          this.loading.startLoading();
          //0-关闭 1-激活 2-撤销
          let postData = {
            id: this.$route.query.id,
            operateFlag: type,
            oaId: this.userInfo.oaId,
          };
          const res = await this.$axios.post(ORDER_API.UPDATE_OTDER_STATUS, postData);
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$router.push({ path: '/salePurchase/purchaseOverview' });
          } else {
            this.$alert(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    // 确认撤销和驳回撤销
    async confirmCancelHandler(params) {
      // 确认是1，驳回是0
      const postData = {
        id: this.$route.query.id,
        approvaResult: params,
        oaId: this.userInfo.oaId,
      };
      const res = await this.$axios.post(ORDER_API.POST_REVERT_API, postData);
      if (res.data.code == 0) {
        this.$message({
          showClose: true,
          message: res.data.msg,
          type: 'success',
        });
        if (params == 0) {
          // 重新拉数据
          this.getOrderDetail();
        } else {
          this.$router.push({ path: '/salePurchase/purchaseOverview' });
        }
      } else {
        this.$message({
          showClose: true,
          message: res.data.msg,
          type: 'error',
        });
      }
    },
  },
};
